<template>
    <v-footer app height="auto" v-if="isVisible && !prerenderMode" py-3 id="privacy-consent-window">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card flat tile color="white" elevation="24">
                    <v-container px-2 v-if="!detailsView" keep-alive>
                        <v-layout row wrap>
                            <v-flex xs12 class="font-weight-bold">
                                {{ 'PC_INTRO_TITLE' | translation }}
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 md8 v-html="$language.translate('PC_INTRO_DESCRIPTION')" />
                            <v-flex xs12 md3 lg2 offset-md1>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-btn :color="themeColor" block @click="onAgreeBtnClick">
                                            {{ 'PC_AGREE_BTN' | translation }}
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-btn block @click="onDeclineBtnClick">
                                            {{ 'PC_DECLINE_BTN' | translation }}
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-btn block @click="detailsView = !detailsView">
                                            {{ 'PC_MORE_BTN' | translation }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-container px-2 v-else keep-alive>
                        <v-layout row wrap align-center>
                            <v-flex xs6 class="font-weight-bold">
                                {{ 'PC_DETAILS_TITLE' | translation }}
                            </v-flex>
                            <v-flex xs2 v-if="$vuetify.breakpoint.mdAndUp">
                                <v-btn :color="themeColor" block @click="onAgreeBtnClick">
                                    {{ 'PC_AGREE_BTN' | translation }}
                                </v-btn>
                            </v-flex>
                            <v-flex xs2 class="pl-1" v-if="$vuetify.breakpoint.mdAndUp">
                                <v-btn block @click="onDeclineBtnClick">
                                    {{ 'PC_DECLINE_BTN' | translation }}
                                </v-btn>
                            </v-flex>
                            <v-flex xs2 class="pl-1" v-if="$vuetify.breakpoint.mdAndUp">
                                <v-btn block @click="detailsView = !detailsView">
                                    {{ 'PC_BACK' | translation }}
                                </v-btn>
                            </v-flex>
                            <v-flex xs4 v-else class="text-xs-right">
                                <v-icon @click="detailsView = !detailsView">keyboard_arrow_left</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 v-html="$language.translate('PC_DETAILS_DESCRIPTION')" />
                            <v-flex xs8 md12>
                                <v-switch v-model="activateAll" :label="$language.translate('PC_ACTIVATE_ALL')" />
                            </v-flex>
                            <v-flex xs4 v-if="$vuetify.breakpoint.smAndDown">
                                <v-btn :color="themeColor" block @click="onAgreeBtnClick">
                                    {{ 'PC_AGREE_BTN' | translation }}
                                </v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <v-divider />
                            </v-flex>
                        </v-layout>
                        <v-container id="privacy-consent-scroll-target" class="scroll-y">
                            <v-layout v-scroll:#scroll-target="onScroll" column>
                                <privacy-consent-item
                                    v-for="item in registeredItems"
                                    :key="item.key"
                                    :title="item.title"
                                    :description="item.description"
                                    :stateKey="item.key"
                                    :value="settings[item.key]"
                                    @onSettingChange="onSettingChange"
                                />
                            </v-layout>
                        </v-container>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
import { mapState } from 'vuex';
import { PRIVACY_MODULE_STORE_NAME, SHOW_PRIVACY_CONSENT_COMPONENT } from '../../constants';
import { eventManager } from '@breakmedia/prime-vue-event-manager';

export default {
    localStorage: {
        [SHOW_PRIVACY_CONSENT_COMPONENT]: {
            type: Boolean,
            default: true,
        },
        [PRIVACY_MODULE_STORE_NAME]: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            detailsView: false,
            activateAll: true,
            settings: {},
            isVisible: false,
        };
    },
    created() {
        this.$router.onReady(() => {
            this.isVisible = this.$localStorage.get(SHOW_PRIVACY_CONSENT_COMPONENT) && !this.$route.query.hcc;

            if (this.$route.query.hcc) {
                this.$router.replace({
                    ...this.$route,
                    query: {
                        ...this.$route.query,
                        hcc: undefined,
                    },
                });
            }
        });

        this.registeredItems.forEach(registeredItem => {
            this.settings[registeredItem.key] = true;
        });
    },
    computed: {
        ...mapState(PRIVACY_MODULE_STORE_NAME, ['registeredItems', 'themeColor']),
        ...mapState('PageContent', ['prerenderMode']),
    },
    methods: {
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
        },
        onSettingChange({ key, value }) {
            this.settings[key] = value;
        },
        onAgreeBtnClick() {
            this.$localStorage.set(SHOW_PRIVACY_CONSENT_COMPONENT, false);
            this.isVisible = false;

            Object.keys(this.settings).forEach(key => {
                this.registeredItems.some(registeredItem => {
                    if (registeredItem.key === key) {
                        this.$store.commit(
                            `${PRIVACY_MODULE_STORE_NAME}/${registeredItem.mutationKey}`,
                            this.settings[key],
                        );
                        this.$localStorage.set(PRIVACY_MODULE_STORE_NAME, this.settings);
                    }
                });
            });

            // Emit consent state change
            this.emitConsentStatus('consentUpdate');
        },
        onDeclineBtnClick() {
            this.$localStorage.set(SHOW_PRIVACY_CONSENT_COMPONENT, false);
            this.isVisible = false;

            this.registeredItems.forEach(registeredItem => {
                this.settings[registeredItem.key] = false;
            });

            Object.keys(this.settings).forEach(key => {
                this.registeredItems.some(registeredItem => {
                    if (registeredItem.key === key) {
                        this.$store.commit(
                            `${PRIVACY_MODULE_STORE_NAME}/${registeredItem.mutationKey}`,
                            this.settings[key],
                        );
                        this.$localStorage.set(PRIVACY_MODULE_STORE_NAME, this.settings);
                    }
                });
            });

            // Emit consent state change
            this.emitConsentStatus('consentUpdate');
        },
        emitConsentStatus(consentStatus) {
            // Aggregate consent statuses based on current settings
            const consentData = this.registeredItems.reduce((acc, item) => {
                (item.consentTypes || []).forEach(consentType => {
                    acc[consentType] = this.settings[item.key] ? 'granted' : 'denied';
                });
                return acc;
            }, {});

            // Emit the aggregated data
            eventManager.$emit(consentStatus, consentData);
        },
    },
    watch: {
        activateAll(value) {
            this.registeredItems.forEach(registeredItem => {
                this.settings[registeredItem.key] = value;
            });
        },
    },
};
</script>

<style scoped>
#privacy-consent-window {
    z-index: 500;
}
#privacy-consent-scroll-target {
    max-height: 115px;
}
</style>
